import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-346078d0")

_pushScopeId("data-v-346078d0")
const _hoisted_1 = { class: "score" }
const _hoisted_2 = { class: "s-body flex justify-between pt12" }
const _hoisted_3 = { class: "left flex align-items-end justify-between" }
const _hoisted_4 = { class: "li flex align-items-center" }
const _hoisted_5 = { class: "right flex align-items-end" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "title" }, "得分：", -1)
const _hoisted_7 = { class: "score" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ui_title_vue = _resolveComponent("ui-title-vue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ui_title_vue, {
      class: "mb32",
      title: "实验得分",
      hasShow: false
    }, {
      body: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data?.typeList, (v) => {
              return (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  class: "mr7",
                  src: v.iconType,
                  width: "18",
                  height: "18"
                }, null, 8, ["src"]),
                _createVNode("div", {
                  class: "mr13",
                  style: `color:${v.color}`
                }, _toDisplayString(v.label), 5),
                _createVNode("div", null, _toDisplayString(v.value), 1)
              ]))
            }), 256))
          ]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.data?.score) + "分", 1)
          ])
        ])
      ]),
      _: 1
    })
  ]))
})